<template>
  <div>
    <!-- // delete dialog -->
    <v-dialog v-model="delete_dialog" max-width="590">
      <v-card>
        <v-card-title class="headline"
          >Are your sure to delete "<strong>{{
            exhibition_to_delete.title
          }}</strong
          >" Exhibition?</v-card-title
        >

        <v-card-text>
          This Exhibition will be deleted.
        </v-card-text>

        <v-card-actions class="pa-3">
          <div class="flex-grow-1"></div>

          <v-btn color="green darken-1" text @click="delete_dialog_close">
            Cancel
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="deleteExhibition(exhibition_to_delete)"
          >
            Delete Exhibition
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="mx-3 elevation-0">
      <v-card-title class="mx-0 px-0">
        <!-- <v-btn to="/exhibitions/new" dark >Add New Exhibition</v-btn> -->

        <v-layout row my-3 mx-1>
          <span>
            <v-menu
              offset-y
              :close-on-content-click="true"
              class="text-xs-right mx-4 my-0 py-0 align-center"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  icon
                  color="black"
                  dark
                  v-on="on"
                  class="text-xs-right mx-0 mt-2 my-0 py-0"
                >
                  <v-icon small>supervisor_account</v-icon>
                </v-btn>
              </template>
              <v-list value="3">
                <v-list-tile
                  v-for="(item, index) in ownerships"
                  :key="index.id"
                  @click="toggleOwnership(item)"
                >
                  <!-- <v-list-tile-avatar v-if="item.id==sorting">
                    <v-icon>mdi-sort-ascending</v-icon>
                  </v-list-tile-avatar> -->
                  <!-- <v-list-tile-avatar v-else>
                    <v-icon></v-icon>
                  </v-list-tile-avatar> -->
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </span>
          <span class="text-xs-left mt-2 pt-1 title">
            {{ selectedOwnership.name }}
          </span>
          <v-spacer></v-spacer>
        </v-layout>

        <v-spacer></v-spacer>

        <v-btn
          small dark
          color="black"
          class="mr-3 mt-3"
          @click="exportToExcel"
        >
          <v-icon small left>mdi-file-excel</v-icon>
          Export to Excel
        </v-btn>

        <v-btn-toggle v-model="loan" class="mt-3 elevation-0">
          <v-btn small flat key="group1" class="px-2" input-value="2" value="2">
            <span> All </span>
          </v-btn>
          <v-btn small flat key="group2" class="px-2" input-value="0" value="0">
            <span> Exhibitions </span>
          </v-btn>
          <v-btn small flat key="group3" class="px-2" input-value="1" value="1">
            <span> Loans </span>
          </v-btn>
        </v-btn-toggle>

        <v-text-field
          v-if="this.$store.state.showSearch"
          append-icon="search"
          clearable
          label="Search "
          single-line
          hide-details
          class="ml-5"
          v-model="search"
        ></v-text-field>
      </v-card-title>

      <v-data-table
        style="border-top: 1px solid #ccc"
        :pagination.sync="pagination"
        hide-headers
        :headers="headers"
        :items="filtered_exhibitions"
        :search="search"
        v-model="selected"
        item-key="id"
        must-sort
        expand
        :loading="$store.state.loading_exhibitions"
        rows-per-page-text="Exhibitions per page"
        no-results-text="No Exhibitions match the criteria."
        class="elevation-0"
      >
        <!-- select-all 
        @change="save_currently_selected_all(selected)" -->

        <template slot="items" slot-scope="props">
          <td
            :class="{ subheading: true, editBG: props.expanded }"
            colspan="6"
            style="padding-left:0px; margin-left:0px;"
          >
            <table class="pa-0 ma-0">
              <tr>
                <!-- <td> {{props.item.duration_start_year}} – {{props.item.duration_end_year}}</td> -->
                <td
                  style="padding-left:0px; margin-left:0px; padding-left:0px; margin-left:0px; padding-top:5px; padding-bottom:0px; height:20px !important;"
                >
                  <!-- {{props.item.duration_start_year.toString().concat(props.item.duration_start_month.toString())}} -->
                  <small
                    class="ml-0"
                    v-if="props.item.duration_start || props.item.duration_end"
                    >{{ props.item.duration_start }} –
                    {{ props.item.duration_end }}</small
                  >
                  <!-- <small class="ml-0" v-if="props.item.institution_id">
                    – {{ getInstitutionName(props.item.institution_id) }}</small
                  > -->
                  <small class="ml-0" >
                    <!-- v-else -->
                    – {{ props.item.institution_name }}</small
                  >
                </td>
              </tr>
              <tr>
                <td
                  class="py-0"
                  :class="{ editBG: props.expanded }"
                  style="padding-left:0px; margin-left:0px; padding-bottom:0px; margin-bottom:0px;"
                >
                  <span class="my-0 title font-weight-light">
                    <router-link
                      class="mr-3"
                      :to="{
                        name: 'EditExhibition',
                        params: { id: props.item.id, exhibition: props.item },
                        path: `/exhibitions/edit/${props.item.id}`
                      }"
                      v-html="stripHtml(props.item.title)"
                    ></router-link>
                  </span>
                </td>
              </tr>
            </table>
          </td>
          <td
            style="width:30px;"
            :class="{
              'text-xs-right': true,
              editBG: props.expanded,
              'pr-0': true,
              'mr-0': true
            }"
          >
          <!-- SELECTION FUNCTIONS  -->
          <v-layout class="px-4 pb-2">
                  <v-tooltip bottom class="mr-3">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="black"
                        icon
                        small
                        @click="loadSelection(props.item.artworks)"
                        v-on="on"
                      >
                        <v-icon small color="white">apps</v-icon>
                      </v-btn>
                    </template>
                    <span
                      >Replace Current Selection with this saved Selection</span
                    >
                  </v-tooltip>

                  <v-tooltip bottom class="mr-3">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="black"
                        icon
                        small
                        @click="addToSelection(props.item.artworks)"
                        v-on="on"
                      >
                        <v-icon small color="white">add</v-icon>
                      </v-btn>
                    </template>
                    <span
                      >Add Artworks in this Exhibition to current Selection</span
                    >
                  </v-tooltip>
                  <v-tooltip bottom class="mr-3">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="black"
                        icon
                        small
                        @click="addSelectionToExhibition(props.item)"
                        v-on="on"
                      >
                        <v-icon small color="white">add</v-icon>
                      </v-btn>
                    </template>
                    <span
                      >Add Artworks in current Selection to this Exhibition</span
                    >
                  </v-tooltip>

                  <!-- <v-tooltip bottom class="mr-3">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="ml-4"
                        icon
                        color="red"
                        v-on="on"
                        small
                        outline
                        @click="removeFromSelections(props.item.artworks)"
                        v-if="c_user.edit || c_user.delete_rights"
                      >
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete Selection</span>
                  </v-tooltip> -->

                  <list-action-menu :item="props.item" ids></list-action-menu>
                </v-layout>
          </td>
          <td
            style="width:30px;"
            :class="{
              'text-xs-right': true,
              editBG: props.expanded,
              'pr-0': true,
              'mr-0': true
            }"
          >
            <v-btn
              class="pl-3"
              small
              round
              outline
              @click="props.expanded = !props.expanded"
              v-if="props.item.artworks.length > 0"
            >
              show {{ props.item.artworks.length }} artworks
              <v-icon v-if="props.expanded">expand_more</v-icon>
              <v-icon v-if="!props.expanded">expand_less</v-icon>
            </v-btn>
          </td>
          <td class="pr-0 mr-0">
            <v-tooltip top v-if="c_user.delete_rights">
              <template #activator="data">
                <span v-on="data.on">
                  <v-btn
                    style="width:20px; height:20px"
                    round
                    color="red"
                    icon
                    small
                    dense
                    @click="deleteExhibition(props.item)"
                    hint="Delete exhibition"
                  >
                    <v-icon small dense color="white">remove</v-icon>
                  </v-btn>
                </span>
              </template>
              Delete Exhibition
            </v-tooltip>
          </td>
        </template>

        <template v-slot:expand="props">
          <v-flex
            style="background-color:#292929; color: #eee;"
            class="px-3 py-1 my-0 elevation-0 xs12"
          >
            <h3 class="font-weight-bold subtitle xs12 flex">ARTWORKS</h3>
          </v-flex>
          <ListRelated
            :artworks="props.item.artworks"
            :exhibition_id="props.item.id"
          ></ListRelated>
          <v-flex
            style="background-color:#292929; color: #eee;"
            class="px-3 py-1 my-0 elevation-0 xs12"
          >
            <h3 class="font-weight-bold subtitle xs12 flex">&nbsp; &nbsp;</h3>
          </v-flex>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <index-load-state
            :loading="$store.state.loading_exhibitions"
            :error="$store.state.load_errors.exhibitions"
            empty-text="No Exhibitions Found."
          ></index-load-state>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { serverBus } from '../../main'
import ListRelated from './ListRelated'
import ListActionMenu from '../artworks/ListActionMenu'
import IndexLoadState from '@/components/general/IndexLoadState.vue'
import XLSX from 'xlsx'
export default {
  data() {
    return {
      ownerships: [],
      filtered: [],
      exhibitions: [],
      selectedOwnership: {},
      // table_exhibitions: [],
      exhibition_to_delete: '',
      delete_dialog: false,
      delete_step: 0,
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'duration_start'
      },
      relatedShown: [],
      fields: ['artwork_location_id', 'type_of_work_id'],
      dialog: false,
      ta: [],
      selected: [],
      loan: '1',
      search: '',
      headers: [
        { text: 'Start Year', sortable: true, value: 'duration_start' },
        { text: 'End Year', sortable: true, value: 'duration_end' },
        { text: 'Title', align: 'left', sortable: true, value: 'title' },
        { text: 'Institution', sortable: true, value: 'institution_name' },
        { sortable: false, value: 'city' },
        { sortable: false, value: 'country' },
        // { text: 'Start-End', value: 'duration_start', align: 'right' },
        { text: '', value: 'artwork_text', sortable: false },
        { text: '', sortable: false }
        // { text: '', value: '', align: 'center', }
        // { text: 'Tags', value: 'tags', sortable: false }
      ]
    }
  },
  created: function() {
    this.$store.dispatch('loadExhibitions')
    // this.exhibitions = Object.assign([], this.$store.state.exhibitions);
    this.ownerships = Object.assign([], this.$store.getters.my_ownerships)
    this.ownerships.unshift({ id: 'all', name: 'All' })
    // this.filtered = this.exhibitions;
    serverBus.$on('setSorting', a => {
      this.pagination.sortBy = a
      this.pagination.descending = !this.pagination.descending
    })
    console.log(this.$store.state.filters['exhibitions'])
    console.log(this.ownerships[0])
    this.toggleOwnership(
      this.$store.state.filters['exhibitions']
        ? this.ownerships.find(
            ow => ow.id == this.$store.state.filters['exhibitions']
          )
        : this.ownerships[0]
    )
    // this.toggleOwnership(this.ownerships[0]);
  },
  methods: {
    exportToExcel() {
      // Prepare data for export
      
      // var eas = exhibition.artworks.map(am => am.id)
      // var o = this.$store.state.artworks.filter(a => eas.includes(a.id))

      console.log(this.filtered_exhibitions[0].artworks)
      const data = this.filtered_exhibitions.map(exhibition => ({
        'Start Year': exhibition.duration_start,
        'End Year': exhibition.duration_end,
        'Title': exhibition.title,
        'Institution': exhibition.institution_name,
        'City': exhibition.city,
        'Country': exhibition.country,
        'Artworks': exhibition.artworks && exhibition.artworks.length ? exhibition.artworks.map(a => {
          const artwork = this.$store.state.artworks.find(b => b.id == a.id);
          return artwork ? '[' + artwork.accession_number + ': ' + artwork.title + ']' : 'Not set';
        }).join(', ') : ''
      }))

      // Create worksheet
      const ws = XLSX.utils.json_to_sheet(data)
      
      // Create workbook
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Exhibitions')
      
      // Generate Excel file
      XLSX.writeFile(wb, `exhibitions_${new Date().toISOString().split('T')[0]}.xlsx`)
    },
    loadSelection(e) {
      var ids = e.map(ea => ea.id)
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      this.$store.dispatch('saveCurrentSelection', ids)
      // } else {
      //   // console.log('no add')
      //   this.$store.dispatch('addToCurrentSelection',e)
      // }
    },
    addSelectionToExhibition(e) {
      // var ids = e.map(ea => ea.id)
      console.log(this.$store.state.currentSelection)
      this.$store.dispatch('addSelectionToExhibition', e)
    },
    addToSelection(e) {
      // map only ids from e
      var ids = e.map(ea => ea.id)
      
      console.log(ids)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      // this.$store.dispatch('saveCurrentSelection',e)
      // } else {
      //   // console.log('no add')
      this.$store.dispatch('addToCurrentSelection', ids)
      // }
    },
    removeFromSelections(e) {
      var ids = e.map(ea => ea.id)
      // console.log(e)
      this.$store.dispatch('removeFromSelections', ids)
    },

    // getInstitutionName(id) {
    //   const i = this.$store.state.contacts.find(i => i.id == id)
    //   if (i) {
    //     return i.name
    //   } else {
    //     return 'institution not found'
    //   }
    // },
    toggleOwnership(o) {
      console.log(o)
      // var array = [];
      // for (var i in ownerships) {
      //   // array.push(i);
      //   array.push(ownerships[i]);
      // }
      this.$store.dispatch('setFilter', {
        section: 'exhibitions',
        ownership: o.id
      })
      this.selectedOwnership = o
    },
    delete_dialog_close() {
      this.delete_dialog = false
      this.delete_step = 0
    },
    deleteExhibition(e) {
      if (this.delete_step == 0) {
        this.delete_dialog = true
        this.delete_step = 1
        this.exhibition_to_delete = e
      } else {
        this.$store.dispatch('deleteExhibition', e)
        this.delete_dialog = false
        this.delete_step = 0
        // console.log('deleted')
      }
    },
    showRelated(id) {
      if (this.relatedShown[id] == true) {
        this.relatedShown[id] = false
      } else {
        this.relatedShown[id] = true
      }
      // console.log(this.relatedShown)
    },
    addField() {},
    switchSwitch() {
      // this.show_tag_filter = !this.show_tag_filter
      this.$emit('switchOwnershipTop', this.show_tag_filter)
    },
    clearFilters() {
      this.selected_tags = []
      this.selected_tag_categories = []
    }
  },
  computed: {
    filtered_exhibitions() {
      let filtered = []
      if (this.selectedOwnership.id != 'all') {
        filtered = this.$store.state.exhibitions.filter(a =>
          a.artworks.some(ea => ea.ownership == this.selectedOwnership.id)
        )
      } else {
        filtered = this.$store.state.exhibitions
      }

      // this.table_exhibitions = this.filtered;
      if (this.loan == 1) {
        filtered = filtered.filter(e => e.loan == 1)
      } else if (this.loan == 0) {
        filtered = filtered.filter(e => e.loan != 1)
      } else {
        filtered = filtered
      }
      let out = []
      filtered.forEach(te => {
        let aids = te.artworks.map(tea => tea.id)
        let as = Object.assign(
          [],
          this.$store.state.artworks.filter(a => aids.includes(a.id))
        )
        te.artwork_text = as
          .map(
            aa =>
              `${aa.accession_number} ${aa.title} ${aa.name} ${aa.artist_name}`
          )
          .toString()
        out.push(te)
      })
      return out
    },
    add_new: {
      get() {
        return this.$store.state.add_new
      },
      set(value) {
        this.$store.dispatch('addNew', value)
      }
    },
    currrent_path() {
      return this.$route.params.ownership
    }
    // table_exhibitions () {
    //   // if (this.selected_tags.length > 0) {
    //   //   var cst = this.selected_tags
    //     return this.$store.state.exhibitions
    //     // .filter(function(artwork) {
    //   //     return artwork.tags.some(a_tag => cst.indexOf(a_tag.id) > -1)
    //   //   })
    //   // } else {
    //     // return this.items
    //     // $store.state.artworks
    //   // }
    // },
  },
  // components: { ListActionMenu, LocationChangeDialog },
  components: { ListRelated, ListActionMenu, IndexLoadState }
}
</script>

<style scoped>
/* td {
  height: 50px !important;
} */
a {
  text-decoration: none;
  color: #333;
}
/* a:hover {text-decoration: underline; color: #000} */
h3 a:hover {
  text-decoration: underline;
  color: #000;
}
/*.hoverDetect:hover img {
    -webkit-transform: scale(3);
    -moz-transform: scale(3);
    -ms-transform: scale(3);
    transform: scale(3); */
/* -webkit-transition: -webkit-transform .1s ease-out;
    -webkit-transition: transform .1s ease-out;
    -moz-transition: transform .1s ease-out;
    transition: transform .1s ease-out; */
/* } */
</style>



// WEBPACK FOOTER //
// src/components/exhibitions/IndexTable.vue